<script setup lang="ts">
import IMask from 'imask'
import type { FactoryArg } from 'imask'

const props = defineProps<{
  maskOptions: FactoryArg
  modelValue?: string
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void
}>()

const wrapperRef = ref<HTMLElement | null>(null)
let maskInstance: IMask.InputMask<IMask.AnyMaskedOptions> | null = null

function attachMask() {
  const input = wrapperRef.value?.querySelector<HTMLInputElement>('input')
  if (!input) return

  const value = props.modelValue ?? maskInstance?.value ?? ''
  maskInstance?.destroy()
  maskInstance = IMask(input, props.maskOptions)
  maskInstance.value = value
  maskInstance.on('accept', () => {
    emit('update:modelValue', maskInstance?.value ?? '')
  })
}

onMounted(() => { void nextTick(attachMask) })

watch(() => props.modelValue, (value) => {
  if (!maskInstance) return
  if (maskInstance.value !== (value ?? '')) {
    maskInstance.value = value ?? ''
  }
})

watch(() => props.maskOptions, () => {
  void nextTick(attachMask)
}, { deep: true })

onUnmounted(() => {
  maskInstance?.destroy()
})
</script>

<template>
  <div ref="wrapperRef" style="display: contents">
    <slot />
  </div>
</template>
